import {
  Button,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  GRAY,
} from "../../../constants/colors";
import { useRecoilState } from "recoil";
import { customColors } from "../../../atoms/customColors";

export default function ModalConfirmationTerms({ isOpen, setIsOpen }: any) {
  // const finalRef = React.useRef(null);
  const colors = useRecoilState(customColors)[0];

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal
        // finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"}>Termos de uso</Text>
            </Flex>
          </ModalHeader>
          <ModalBody>
            <Flex
              w={"100%"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Text>Textinho bonito</Text>
            </Flex>
            
          </ModalBody>
          <ModalFooter justifyContent={"space-evenly"}>
            <Button 
              background={colors.GRAY} 
              color={"white"} 
              mr={3} 
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button 
              background={GRAY} 
              color={"white"} 
              mr={3} 
              onClick={onClose}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
